







































































import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME, EventFrequencies } from './constants';

export default editFactory(NAME, store).extend({
	methods: {
		isDateVisible() {
			return !this.IsImmediate && (this.FrequencyId === EventFrequencies.Monthly || this.FrequencyId === EventFrequencies.Quarterly);
		},
		isDayVisible() {
			return this.FrequencyId === EventFrequencies.Weekly && !this.IsImmediate;
		},
		isReminderFieldsVisible() {
			return this.IsReminder && !this.IsImmediate;
		},
		isFrequencyVisible() {
			return !this.IsImmediate;
		},
		isMonthVisible() {
			return !this.IsImmediate && this.FrequencyId === EventFrequencies.Quarterly;
		},
	},
});
